import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { useAuth } from '@/hooks/useAuth';

export function PractitionerMobileMoreMenuFooter() {
  const { t } = useTranslation('common');
  const { logOut } = useAuth();

  return (
    <div className="col-span-2 mt-1 pt-2 border-t border-zooborder flex items-center justify-between gap-2 px-1">
      <LanguageSwitcher />
      <button
        type="button"
        onClick={function handleLogout() {
          logOut();
        }}
        className="min-h-[44px] flex items-center gap-2 px-3 rounded-xl text-sm font-medium text-zooerrortext hover:bg-zooerrorbg transition-colors"
      >
        <Icon name="LogOut" />
        {t('actions.logout')}
      </button>
    </div>
  );
}
